import React from 'react'
import {withRouter, Redirect} from 'react-router-dom'
import {Col, Nav, NavItem, NavLink, Row, TabContent, TabPane, Form, Label, Input, Button, ListGroup} from 'reactstrap'
import Websocket from "react-websocket"
import Loader from 'react-loader-spinner'
import {ModelListTable} from '../../ui'
import classnames from 'classnames'
import { getMySubscriptionPlan, } from "../../../dataHelpers/subscriptionHelpers"
import {Controller, Team, AppError, UserConfirmationRequest, UserSelectionRequest} from '../../../models'
import {getControllers, getPastControllers, getTeam, RESPONSE_PAGE_SIZE,
    WS_URL, allcontrollerstatus, lookupUserByEmail, planlist,
    assignControllerTeam, unassignControllers,
    getController,
    sendArchiveController} from "../../../api"
import {ControllerListTable, ControllerMap, Paginator, ControllerAssignmentListItem, AdminLinkBubble} from '../../ui'
import {pageHelpers} from '../'

import ControllerIcon from 'react-icons/lib/fa/square'
import CustomerControllerIcon from 'react-icons/lib/fa/square-o'

import '../../../stylesheets/Controllers.css'

class ListPage extends React.Component {
    constructor(props) {
        super(props)
        pageHelpers.setupPropsForPage(props, this)
        const {token} = props

        let teamID = this.urlParams.team_id
        if (!teamID && this.user) {
            teamID = this.user.activeTeam
        }

        this.state = {
            token,
            loading: false,
            loadingControllers: false,
            errors: [],
            controllers: [],
            currentControllerPage: this.queryParams.controllerPage || 1,
            controllerCount: RESPONSE_PAGE_SIZE,
            customerControllers: [],
            currentCustomerControllerPage: this.queryParams.customerControllerPage || 1,
            customerControllerCount: RESPONSE_PAGE_SIZE,
            highlightedController: -1,
            teamName: '',
            showArchived: this.queryParams.tab || false,
            phone: this.queryParams.search ||"",
            selectedOption: this.queryParams.option ||"",
            teamID,
            teamIsDealership: false,
            activeTab: this.queryParams.tab || "1",
            sortBy: this.queryParams.sort || null,
            sortDescending: this.queryParams.descending == 'true',
            deletearchivecontrollers:true,
            selectedControllers: [],
            availablePlans: [],
            userConfirmationRequests: [],
            userSelectionRequests: [],
            unassignedControllers: [],
            assignedControllers: [],
        }

        this.fetchControllers = this.fetchControllers.bind(this)
        this.fetchPastControllers = this.fetchPastControllers.bind(this)
        this.fetchTeam = this.fetchTeam.bind(this)
        this.fetchControllerStatus = this.fetchControllerStatus.bind(this)

        this.switchTab = this.switchTab.bind(this)

        this.handleTeamWebSocketResponse = this.handleTeamWebSocketResponse.bind(this)
        this.handleControllerWebSocketResponse = this.handleControllerWebSocketResponse.bind(this)
        this.handleCustomerControllerWebSocketResponse = this.handleCustomerControllerWebSocketResponse.bind(this)

        this.mapControllerMouseOverHandler = this.mapControllerMouseOverHandler.bind(this)
        this.mapControllerMouseOutHandler = this.mapControllerMouseOutHandler.bind(this)
        this.mapControllerClickHandler = this.mapControllerClickHandler.bind(this)

        this.tableControllerMouseOverHandler = this.tableControllerMouseOverHandler.bind(this)
        this.tableControllerMouseOutHandler = this.tableControllerMouseOutHandler.bind(this)
        this.tableControllerClickHandler = this.tableControllerClickHandler.bind(this)
        this.tableSortClickHandler = this.tableSortClickHandler.bind(this)
        this.clearSearch = this.clearSearch.bind(this)
        this.handleInput1Change = this.handleInput1Change.bind(this)
        this.handleSelectedControllersChange = this.handleSelectedControllersChange.bind(this)
        this.dismissUserConfirmationRequest = this.dismissUserConfirmationRequest.bind(this)
        this.dismissUserSelectionRequest = this.dismissUserSelectionRequest.bind(this)
        this.submitDealerForm = this.submitDealerForm.bind(this)
        this.submitUnassignForm = this.submitUnassignForm.bind(this)
        this.submitDeleteController = this.submitDeleteController.bind(this)
    }

    async componentWillReceiveProps(nextProps) {
        pageHelpers.setupPropsForPage(nextProps, this)
        const {token} = nextProps

        let {currentControllerPage,showArchived, deletearchivecontrollers, currentCustomerControllerPage, activeTab, teamID, controllers, controllerCount, customerControllers, customerControllerCount, teamIsDealership, phone, selectedOption, sortBy, sortDescending} = this.state

        let newTeamID = this.urlParams.team_id
        if (!newTeamID && this.user) {
            newTeamID = this.user.activeTeam
        }

        if (teamID && parseInt(teamID) > 0 && teamID !== newTeamID) {
            teamID = newTeamID
            currentControllerPage = 1
            controllers = []
            controllerCount = 0
            currentCustomerControllerPage = 1
            customerControllers = []
            customerControllerCount = 0
            activeTab = '1'
            teamIsDealership = false
            sortBy = null
            sortDescending = false
            phone = ''
            selectedOption = ''
            showArchived = ''
            deletearchivecontrollers =false
        } else {
            teamID = newTeamID
            currentControllerPage = this.queryParams.controllerPage || currentControllerPage
            currentCustomerControllerPage = this.queryParams.customerControllerPage || currentCustomerControllerPage
            activeTab = this.queryParams.tab || activeTab
            sortBy = this.queryParams.sort
            sortDescending = this.queryParams.descending == 'true'
            phone = this.queryParams.search
            selectedOption = this.queryParams.option
            showArchived = this.queryParams.showArchived
            deletearchivecontrollers = ''
        }


        await this.setState({
            token,
            teamID,
            controllers,
            controllerCount,
            currentControllerPage,
            customerControllers,
            customerControllerCount,
            currentCustomerControllerPage,
            activeTab,
            teamIsDealership,
            sortBy,
            sortDescending
        })

        if (token && teamID) {
            this.setState({loadingControllers: true})
            await this.fetchTeam()
            await this.fetchControllers()
            await this.fetchControllerStatus()
            this.setState({loadingControllers: false})
        }
    }

    async componentDidMount() {
        let {token, teamID} = this.state
        if (token && teamID) {
            this.setState({loading: true})
            await this.fetchTeam()
            await this.fetchControllers()
            await this.fetchControllerStatus()
            this.setState({loading: false})
        }
    }

    async fetchTeam() {
        let {teamID, teamName, teamIsDealership, token} = this.state
        try {
            let team = await getTeam(token, teamID, 'pico')
            if (teamName !== team.name || team.dealership !== teamIsDealership) {
                this.setState({teamName: team.name, teamIsDealership: team.dealership})
            }
        } catch (err) {
            console.log(err)
        }
    }

    async fetchPastControllers() {
        if(window.location.href.indexOf("?") < 0){
            this.setState({showArchived :false, deletearchivecontrollers:true})
        }
        let {teamID, currentCustomerControllerPage, sortBy, sortDescending, token,phone, selectedOption, deletearchivecontrollers, showArchived } = this.state
        try {
            let useMicroSerializer = true
            let response = await getPastControllers(token, teamID, true, currentCustomerControllerPage, RESPONSE_PAGE_SIZE, sortBy, sortDescending,phone, selectedOption, showArchived, useMicroSerializer)
            let customerControllers = response.results
            let customerControllerCount = response.count
            this.setState({customerControllers, customerControllerCount})
        } catch (err) {
            console.log(err)
        }
    }

    async fetchControllers() {
        if(!window.location.search){
            this.setState({selectedOption :''})
        }
        if(!window.location.href.includes('?')){
            this.setState({currentControllerPage :1})
        }
        let {teamIsDealership, teamID, currentControllerPage, activeTab, showArchived, sortBy, sortDescending, token, availablePlans, phone, selectedOption,deletearchivecontrollers} = this.state
        this.setState({loadingControllers: true})
        try {
            let {results, count} = await getControllers(token, teamID, false, false, false, currentControllerPage, RESPONSE_PAGE_SIZE, sortBy, sortDescending, phone, selectedOption, showArchived)
            let planResponse = await planlist(token)
    
            const subscriptionPromises = results.map(con => getMySubscriptionPlan(token, con.id));
            const subscriptions = await Promise.all(subscriptionPromises);
    
            results = results.map((con, index) => {
                const subResponse = subscriptions[index];
                if (subResponse.serial_number === con.serialNumber) {
                    con.subscriptionPlan = subResponse.subscription_plan;
                }
                return con;
            });
    
            this.setState({controllers: results, controllerCount: count, availablePlans: planResponse})
            if (teamIsDealership && activeTab === '2') {
                await this.fetchPastControllers()
            }
        } catch (error) {
            console.log(error)
        } finally {
            this.setState({loadingControllers: false})
        }
    }

    async fetchControllerStatus() {
        try {
            let {token, teamID, controllers, customerControllers} = this.state
            this.setState({ loading: true })
            let statusResponse
	    
	    if (teamID) {
                statusResponse = await allcontrollerstatus(token, teamID)
                
	    } else {
            statusResponse = await allcontrollerstatus(token)
	    }

            

            for (let i = 0; i < controllers.length; i++) {
                let c = controllers[i]
                statusResponse.map(s => {
                    if (s.serial_number && c.serialNumber && c.serialNumber == s.serial_number) {
                        c.subscriptionStatus = s.subscription_status
			controllers[i] = c
                    }
                })
            }

            for (let i = 0; i < customerControllers.length; i++) {
                let c = customerControllers[i]
                statusResponse.map(s => {
                    if (s.serial_number && c.serialNumber && c.serialNumber == s.serial_number) {
                        c.subscriptionStatus = s.subscription_status
			customerControllers[i] = c
                    }
                })
            }

            this.setState({ controllers, customerControllers })
        } catch (error) {
            console.log(error)
        }
        this.setState({ loading: false })
    }


    async handleTeamWebSocketResponse(data) {
        let team = Team.fromAPIObject(JSON.parse(data))
        await this.setState({teamName: team.name, teamIsDealership: team.dealership})
        await this.fetchControllers()
        await this.fetchControllerStatus()
    }

    handleControllerWebSocketResponse(data) {
        let {controllers} = this.state
        let newController = Controller.fromAPIObject(JSON.parse(data))
        if (controllers && controllers.filter) {
            let filteredControllers = controllers.filter((c) => c.id !== newController.id)
            filteredControllers.push(newController)
            controllers = filteredControllers
            this.setState({controllers})
        }
    }

    handleCustomerControllerWebSocketResponse(data) {
        let {customerControllers} = this.state
        let newController = Controller.fromAPIObject(JSON.parse(data))
        if (customerControllers && customerControllers.filter) {
            let filteredControllers = customerControllers.filter((c) => c.id !== newController.id)
            customerControllers = filteredControllers.push(newController)
            this.setState({customerControllers})
        }
    }

    mapControllerMouseOverHandler(controller) {
        this.setState({highlightedController: controller.id})
    }

    mapControllerMouseOutHandler(controller) {
        this.setState({highlightedController: -1})
    }

    mapControllerClickHandler(controller) {
        this.history.push(`/controllers/${controller.id}`)
    }

    tableControllerMouseOverHandler(event, controller) {
        this.setState({highlightedController: controller.id})
    }

    tableControllerMouseOutHandler(event, controller) {
        this.setState({highlightedController: -1})
    }

    tableControllerClickHandler(event, controller) {
        this.history.push(`/controllers/${controller.id}`)
    }

    handleInput1Change = (e) => {
        let value = e.target.value
        let {phone, teamID, showArchived, deletearchivecontrollers} =this.state
        if(value){
        this.setState({phone: e.target.value});
        } else if(window.location.href.indexOf("teams") > -1){
            this.setState({phone: ''});
            this.props.history.push('/teams/'+teamID+'/controllers');
        } else{
            this.setState({phone: '',showArchived:false});
            this.props.history.push('/controllers/');
        }
    }

    clearSearch() {
        let {teamID} = this.state
        this.setState({phone :''})
        if (window.location.href.indexOf("teams") > -1){
            this.props.history.push('/teams/'+teamID+'/controllers');
        } else{
            this.props.history.push('/controllers/');
        }    
    }
  
    tableSortClickHandler(event, sortByField) {
        
        let {activeTab, activeControllers, teamID, phone, userConfirmationRequests, currentControllerPage,deletearchivecontrollers, currentCustomerControllerPage,searchByName, teamIsDealership, sortBy, sortDescending,selectedOption} = this.state
        if (sortByField === sortBy && !sortDescending && sortByField !='searchbyname' && sortByField !='currentstatus') {
            sortDescending = true
        } else if (sortByField === sortBy && sortDescending && sortByField !='searchbyname' && sortByField !='currentstatus') {
            sortByField = null
            sortDescending = false
            this.history.push({
                pathname: this.history.location.pathname,
                search: `?controllerPage=${currentControllerPage}`
            })
        } else {
            sortDescending = false
        }

        if (sortByField && teamIsDealership && sortByField=="currentstatus") {
            
            let selectedOption
            if(sortByField == 'currentstatus'){
                selectedOption = event.target.value
                this.setState({selectedOption:selectedOption})
            } else{
                selectedOption = ''
            }
            if((selectedOption == '') && (window.location.href.indexOf("teams") > -1)){
                this.props.history.push('/teams/'+teamID+'/controllers');
            } else{
            currentControllerPage = 1
            this.history.push({
                pathname: this.history.location.pathname,
                search: `?tab=${activeTab}&controllerPage=${currentControllerPage}&customerPage=${currentCustomerControllerPage}&sort=${sortByField}&descending=${sortDescending}&search=${phone}&option=${selectedOption}`
            })
            }
        } else if (sortByField!="searchbyname" && sortByField != "currentstatus" && sortByField!="deletearchive") {
            this.history.push({
                pathname: this.history.location.pathname,
                search: `?controllerPage=${currentControllerPage}&sort=${sortByField}&descending=${sortDescending}&search=${phone}&option=${selectedOption}`
            })
        }
        else if (teamIsDealership && !sortByField) {
            this.history.push({
                pathname: this.history.location.pathname,
                search: `?tab=${activeTab}&controllerPage=${currentControllerPage}&customerPage=${currentCustomerControllerPage}`
            })
        }  else if (sortByField == "searchbyname") {
            const element = document.getElementById("searchname");
            phone = element.value
            currentControllerPage = 1
            this.setState({phone:phone})
            this.history.push({
                pathname: this.history.location.pathname,
                search: `?controllerPage=${currentControllerPage}&sort=${sortByField}&descending=${sortDescending}&search=${phone}&option=${selectedOption}`
            })
            var el = document.getElementById("searchname");
            el.value = phone;
        }     else if (sortByField == "currentstatus") {
                currentControllerPage = 1
                let {controllers} = this.state
                let selectedOption = event.target.value
                this.setState({selectedOption:selectedOption})
                if((selectedOption == '') && (window.location.href.indexOf("teams") > -1)){
                    this.props.history.push('/teams/'+teamID+'/controllers');
                }else if((selectedOption == '') &&  (window.location.href.indexOf("/controllers") > -1)){
                    this.props.history.push('/controllers/');
                }
                else {
                this.history.push({
                pathname: this.history.location.pathname,
                search: `?controllerPage=${currentControllerPage}&sort=${sortByField}&descending=${sortDescending}&search=${phone}&option=${selectedOption}`
            })}
        }
    }
    

    async switchTab(tab) {
        let {activeTab, currentControllerPage, showArchived, deletearchivecontrollers, currentCustomerControllerPage, teamIsDealership} = this.state
        this.setState({selectedControllers: [], assignedControllers: [], unassignedControllers: [],})
        if (activeTab !== tab && teamIsDealership) {
            this.setState({phone :'', deletearchivecontrollers:true, showArchived:false,selectedOption :''})
            this.history.push({
                pathname: this.history.location.pathname,
                search: `?tab=${tab}&controllerPage=${currentControllerPage}&customerPage=${currentCustomerControllerPage}`
            })
        }
    }

    handleSelectedControllersChange(selectedControllers) {
        if (selectedControllers && selectedControllers.length) {
            this.setState({activeInfoAlert: 1})
        } else {
            this.setState({activeInfoAlert: 0})
        }
        this.setState({selectedControllers})

    }

    dismissUserConfirmationRequest() {
        this.setState({userConfirmationRequests: [], loading: false})
    }

    dismissUserSelectionRequest() {
        this.setState({userSelectionRequests: [], loading: false})
    }
    /*get all checked controllers in selectedControllers variable and 
    passes the reuqest to the sendarchive controller check first if it
     contains data or not if not then show warning message */
    async submitDeleteController() {
        let{controllers, currentControllerPage, phone, token, showArchived, selectedControllers} = this.state
        let confirm = async () =>{
            this.setState({loading:false,userConfirmationRequests: []})
        }
        if(selectedControllers.length<=0){
            let request = new UserConfirmationRequest('Delete Archive Controller',
            'Please Select atleast one controller',confirm,
            this.dismissUserConfirmationRequest)
            await this.setState({userConfirmationRequests: [request]})
        } else if(selectedControllers.length>=1){
            let anyController = []
            let getControle = ''
                for (let i = 0; i < selectedControllers.length; i++) {
                    getControle = await getController(token, selectedControllers[i]);
                    if(!getControle.archived){
                        anyController.push(getControle);
                        let confirm = async () =>{
                            this.setState({loading:false,userConfirmationRequests: []})
                        }
                    }
                }    
                if(anyController.length>=1){
                    let request = new UserConfirmationRequest('Delete Archive Controller',
                    'Please Select archive controllers only',confirm,
                    this.dismissUserConfirmationRequest)
                    await this.setState({userConfirmationRequests: [request]})
                }  else{
                        let confirm1 = async () =>{
                            this.setState({loading:false,userConfirmationRequests: []})
                            let result = await sendArchiveController(token, selectedControllers)
                            if(result.success){
                                alert('Archive Controller has been deleted ')
                                const delay = ms => new Promise(res => setTimeout(res, ms));
                                await delay(1000);
                                let resp = await this.setState({selectedControllers:[]})
                                this.history.push({
                                    pathname: this.history.location.pathname
                                })
                            } else{
                                let request1 = new UserConfirmationRequest('Delete Archive Controller',
                                `${result.error}`,confirm,
                                this.dismissUserConfirmationRequest)
                                await this.setState({userConfirmationRequests: [request1]})
                            }
                        }
                      
                    let request = new UserConfirmationRequest('Delete Archive Controller',
                    'Are you sure, you want to delete this selected controller.',confirm1,
                     this.dismissUserConfirmationRequest)
                    await this.setState({userConfirmationRequests: [request]})
                }
            }
        }

    async submitUnassignForm(e) {
        e.preventDefault()
        let {selectedControllers, customerControllers, teamID, token} = this.state
        if (!selectedControllers || !selectedControllers.length) {
            let appError = new AppError("No Controllers Selected", "Please select the controllers you wish to unassign.")
            this.setState({errors: [appError], loading: false})
            return
        }
        
        let anyControllerExist = []
        for (let i = 0; i < selectedControllers.length; i++) {
            let getControle = await getController(token, selectedControllers[i]);
            if(getControle.archived){
                anyControllerExist.push(getControle);
            }
        }  
        if(anyControllerExist.length>=1){
            let request = new UserConfirmationRequest('Delete Archive Controller',
            'Please select controllers which is not archived',confirm,
            this.dismissUserConfirmationRequest)
            await this.setState({userConfirmationRequests: [request]})
            return
        } 

        let confirm = async () => {
            const controlerData = []
            this.setState({loading: true, userConfirmationRequests: []})
            
            try {
                for (let i = 0; i < selectedControllers.length; i++) {
                    let getControle = await getController(this.token, selectedControllers[i]);
                    let getTeamName = await getTeam(this.token, getControle.team, 'pico');
                    getControle.team = {'id': getTeamName.id, 'name': getTeamName.name};
                    controlerData.push(getControle);
                }
                let team = await getTeam(this.token, teamID)
                let another_user_id = team.users[0].id
                await unassignControllers(this.token, selectedControllers, true, another_user_id);
                await this.setState({unassignedControllers: controlerData, selectedControllers: []})
                
                await this.fetchControllers()
                await this.fetchControllerStatus()
            } catch (error) {
                console.log(error)
                let appError = new AppError("Failed to Unassign Controllers", "There was an issue unassigning the controller. Please verify the serial number and try again")
                await this.setState({errors: [appError]})
            } 
            
        }
        
        
        let firstController = customerControllers.filter(c => c.id === selectedControllers[0])[0]
        
        let controllerMessage = (selectedControllers.length > 1 ?
            `these <strong>${selectedControllers.length}</strong> controllers` :
            `<strong>${firstController.userIdentifiableName}</strong>`)

        let request = new UserConfirmationRequest(`Unassign Controller${selectedControllers.length > 1 ? "s" : ""}`,
            `Are you sure you want to unassign ${controllerMessage}?`,
            confirm,
            this.dismissUserConfirmationRequest)
        await this.setState({userConfirmationRequests: [request]})
        this.setState({loading: false})
    }

    async submitDealerForm(e) {
        e.preventDefault()
        let dismissConfirmations = () => {this.dismissUserConfirmationRequest()}

        let email = e.target['email'].value
        let {selectedControllers, token, teamID, controllers, availablePlans, userConfirmationRequests, assignedControllers, } = this.state

        if (!selectedControllers || !selectedControllers.length) {
            let appError = new AppError("No Controller Selected", `Please select one or more controllers to assign.`)
            await this.setState({errors: [appError], loading: false})
            return
        } else if (!email || !email.length) {
            let appError = new AppError("No Email Specified", `Please enter a user's email address to assign controllers to.`)
            await this.setState({errors: [appError], loading: false})
            return
        }
        let anyControllerExist = []
        for (let i = 0; i < selectedControllers.length; i++) {
            let getControle = await getController(token, selectedControllers[i]);
            if(getControle.archived){
                anyControllerExist.push(getControle);
            }
        }  
        let confirm = async () =>{
            this.setState({loading:false,userConfirmationRequests: []})
        }   
        if(anyControllerExist.length>=1){
            let request = new UserConfirmationRequest('Delete Archive Controller',
            'Please Select  controllers  which is not archived',confirm,
            this.dismissUserConfirmationRequest)
            await this.setState({userConfirmationRequests: [request]})
            return
        } 
        
        let firstController = controllers.filter(c => c.id === selectedControllers[0])[0]
        
        let controllerMessage = (selectedControllers.length > 1 ?
            `these <strong>${selectedControllers.length}</strong> controllers` :
            `<strong>${firstController.userIdentifiableName}</strong>`)

        try {
            let user = await lookupUserByEmail(token, email)

            if (user.teams && user.teams.length > 1) {

                let select = async (selectedTeam) => {
                    // this.setState({loading: true})

                    let cons = controllers.filter(c => selectedControllers.indexOf(c.id) > -1)
                    let serials = cons.map(c => c.id)
                    let subsPlanID = cons.map(c => c.subscriptionPlan)
                    if (subsPlanID && subsPlanID.length) {
                        subsPlanID = subsPlanID[0]
                    }
                    
                    let isSeasonedData = availablePlans.filter((t) => t.id == subsPlanID)
                    if(subsPlanID == null){
                        let confirm = () => {
                            window.location.reload();
                            this.setState({userConfirmationRequests: [], loading: false})
                        }
                        let dismissUserConfirmationRequest = () => {
                            window.location.reload();
                            this.setState({userConfirmationRequests: [], loading: false})
                        }
                     
                        let request1 = new UserConfirmationRequest('Assign Controller',
                        `Subscription Plan not available for this controller.`,
                        confirm,
                        dismissUserConfirmationRequest)
                        this.setState({userConfirmationRequests: [request1]})
                    } else{
                        this.setState({loading: true})

                    let is_seasonedVal = isSeasonedData[0].is_seasoned
                 

                    this.setState({ loading: true })
                    //let controllers = await assignControllers(this.token, serials, selectedTeam.id, true) // client API
                    let controller_res = await assignControllerTeam(token, serials, selectedTeam.id, subsPlanID, is_seasonedVal, teamID, false, this.user.isSupport)

                    assignedControllers = assignedControllers.concat(controller_res)
                    this.setState({
                        assignedControllers,
                        selectedControllers: [],
                        userSelectionRequests: [],
                        loading: false
                    })
                    for (let i = 0; i < this.state.assignedControllers.length; i++) {
                        let controller = this.state.assignedControllers[i]
                        
                        let getTeamName = await getTeam(token, controller.team, 'pico')
                        controller.team = {'id': getTeamName.id, 'name': getTeamName.name}
                
                    }
                    
                    await this.fetchTeam()
                    await this.fetchControllers()
                    await this.fetchControllerStatus()
                    }
                }

                let request = new UserSelectionRequest('Assign Controller',
                    `<strong>${user.firstName} ${user.lastName}</strong> (${email}) ` +
                    " is a member of multiple teams. <br/> " +
                    `Which team do you want to assign ${controllerMessage} to? <br/>`,
                    select,
                    this.dismissUserSelectionRequest,
                    user.teams)

                this.setState({userSelectionRequests: [request]})
                
            } else if (user.teams && user.teams.length === 1) {
                

                let team = user.teams[0]
                let confirm = async () => {
                    
                    let cons = controllers.filter(c => selectedControllers.indexOf(c.id) > -1)
                    let serials = cons.map(c => c.id)
                    let subsPlanID = cons.map(c => c.subscriptionPlan)
                    if (subsPlanID && subsPlanID.length) {
                        subsPlanID = subsPlanID[0]
                    }

                    let isSeasonedData = availablePlans.filter((t) => t.id == subsPlanID)
                    if(subsPlanID == null){
                        let confirm = () => {
                            window.location.reload();
                            this.setState({userConfirmationRequests: [], loading: false})
                        }
                        let dismissUserConfirmationRequest = () => {
                            window.location.reload();
                            this.setState({userConfirmationRequests: [], loading: false})
                        }
                        let request1 = new UserConfirmationRequest('Assign Controller',
                        `Subscription Plan not available for this controller.`,
                        confirm,
                        dismissUserConfirmationRequest)
                        this.setState({userConfirmationRequests: [request1]})
                    } else{
                    let is_seasonedVal = isSeasonedData[0].is_seasoned

                    this.setState({loading: true, userConfirmationRequests: []})
                    //let controllers = await assignControllers(this.token, serials, selectedTeam.id, true) // client API
                    let controller_res = await assignControllerTeam(token, serials, team.id, subsPlanID, is_seasonedVal, teamID, false, this.user.isSupport)
                    assignedControllers = assignedControllers.concat(controller_res)
                    this.setState({
                        assignedControllers,
                        selectedControllers: [],
                        userSelectionRequests: [],
                        loading: false
                    })
                    for (let i = 0; i < this.state.assignedControllers.length; i++) {
                        let controller = this.state.assignedControllers[i]
                        
                        let getTeamName = await getTeam(token, controller.team, 'pico')
                        controller.team = {'id': getTeamName.id, 'name': getTeamName.name}
                    }

                    await this.fetchTeam()
                    await this.fetchControllers()
                    await this.fetchControllerStatus()
                    await this.dismissUserConfirmationRequest()
                    }
                }
                
                let request = new UserConfirmationRequest('Assign Controller',
                    `Are you sure you want to assign ${controllerMessage} to ${team.name}?`,
                    confirm,
                    this.dismissUserConfirmationRequest)
                await this.setState({userConfirmationRequests: [request]})
                
                this.setState({loading: false})

            } else {
                let appError = new AppError("Error", `${user.firstName} ${user.lastName} (${email}) is a user but is not a member of any team.`)
                await this.setState({errors: [appError]})
            }
            
        } catch (error) {
            
            console.log(error)
            let confirm = async () => {
                let serials = selectedControllers.map(sc => controllers.filter(ac => ac.id === sc)[0].serialNumber)
                this.history.push(`/management/teams/provision/customer?email=${email}&controllers=${serials.join(',')}`)
                this.setState({userConfirmationRequests: []})
            }

            let request = new UserConfirmationRequest('Unable to Find User',
                `<strong>${email}</strong> is not associated with any user.<br/> ` +
                `Would you like to create a new team and user for <strong>${email}</strong>?`,
                confirm,
                this.dismissUserConfirmationRequest)
            await this.setState({userConfirmationRequests: [request]})
            
        }
    
    }
   
    render() {
        let {
            errors,loading, controllers, deletearchivecontrollers,highlightedController,phone, selectedOption, currentControllerPage, controllerCount,
            customerControllers, customerControllerCount, currentCustomerControllerPage, teamName, teamID,
            teamIsDealership, loadingControllers, activeTab, sortBy, sortDescending, token, userConfirmationRequests,
            userSelectionRequests, selectedControllers, assignedControllers, unassignedControllers,
        } = this.state

        let activeControllers = (activeTab === '1' ? controllers : customerControllers)
        let activeControllerCount = (activeTab === '1' ? controllerCount : customerControllerCount)
        let activeCurrentPage = (activeTab === '1' ? currentControllerPage : currentCustomerControllerPage)
        let activeBaseURL = `${window.location.pathname}`
        if (teamIsDealership) {
            activeBaseURL += `?activeTab=${activeTab}`
            if (sortBy) {
                activeBaseURL += `&sort=${sortBy}&descending=${sortDescending}`
            }
            if (activeTab === '1') {
                activeBaseURL += `&customerControllerPage=${currentCustomerControllerPage}`
                activeBaseURL += '&controllerPage='
            } else if (activeTab === '2') {
                activeBaseURL += `&controllerPage=${currentControllerPage}`
                activeBaseURL += '&customerControllerPage='
            }
        } else {
            
            if (window.location.href.indexOf("&") > -1) {
                activeBaseURL +=`?sort=${sortBy}&descending=${sortDescending}&search=${phone}&option=${selectedOption}&controllerPage=`
            } else{
                activeBaseURL += "?controllerPage="
            }
        }

        return (loading ? <Loader type="TailSpin" color="orange" width={60} height={60}/> :
            <div className="p-0 m-0">
                {teamIsDealership ?
                    <Col xs={12} className="p-0">
                        <Nav tabs>
                            <NavItem>
                                <NavLink
                                    className={classnames({active: activeTab == '1'})}
                                    onClick={() => {
                                        this.switchTab('1')
                                    }}
                                >
                                    <ControllerIcon className="mr-2"/>
                                    Inventory
                                </NavLink>
                            </NavItem>
                            <NavItem>
                                <NavLink
                                    className={classnames({active: activeTab == '2'})}
                                    onClick={() => {
                                        this.switchTab('2')
                                    }}
                                >
                                    <CustomerControllerIcon className="mr-2"/>
                                    Customer Controllers
                                </NavLink>
                            </NavItem>
                        </Nav>
                    </Col> :
                    null}
                <Col xs={12}
                     className="bg-light large-rounded border-light-sf-orange justify-content-center p-0">
                    <TabContent activeTab={activeTab}>
                        <TabPane tabId="1">
                            <h2 className="col-12 table-head">
                                <ControllerIcon className="light-sf-blue"/>&ensp;
                                {teamName && teamName.length ?
                                    <span>
                                        {teamName}{teamName.endsWith("s") ?
                                        <span>&rsquo; </span> :
                                        <span>&rsquo;s </span>}
                                    </span> :
                                    <span>&hellip; </span>} Controllers
                            </h2>
                            
                            <div >
                            <select className="form-control col-md-3 float-right" name="currentstatus" value ={this.state.selectedOption} onChange={event => this.tableSortClickHandler(event,'currentstatus')} id="currentstatus">
                                <option  className="btn btn-dark" value ="">All controllers</option>
                                <option className="btn btn-primary" value="running">Pump Running</option>
                                <option className="btn btn-primary" value="running_disabled">Pump Stopped</option>
                                <option className="btn btn-success" value="subscription">Subscription Active</option>
                                <option className="btn btn-success" value="subscription_inactive">Subscription Inactive</option>
                                <option className="btn btn-light" value="connectivity">Connectivity Active</option>
                                <option className="btn btn-light" value="connectivity_false">Connectivity Inactive</option>
                                </select>
                            </div>
                            {controllers && controllers.length && token ?
                                controllers.map((con, idx) =>
                                    <Websocket key={`ws-listener-${con.id}-${idx}-${token.accessToken}`}
                                               url={`${WS_URL}/controllers/${con.id}/?access_token=${token.accessToken}`}
                                               onMessage={this.handleControllerWebSocketResponse}/>) :
                                null}
                        </TabPane>
                        <TabPane tabId="2">

                            <h2 className="col-12 table-head"><CustomerControllerIcon className="light-sf-blue"/>&ensp;Customer
                                Controllers</h2>
                            <div >
                                <select className="form-control col-md-3 float-right"  name="currentstatus" value ={this.state.selectedOption} onChange={event => this.tableSortClickHandler(event,'currentstatus')} id="currentstatus">
                                <option  className="btn btn-dark" value ="">All controllers</option>
                                <option className="btn btn-primary" value="running">Pump Running</option>
                                <option className="btn btn-primary" value="running_disabled">Pump Stopped</option>
                                <option className="btn btn-success" value="subscription">Subscription Active</option>
                                <option className="btn btn-success" value="subscription_inactive">Subscription Inactive</option>
                                <option className="btn btn-light" value="connectivity">Connectivity Active</option>
                                <option className="btn btn-light" value="connectivity_false">Connectivity Inactive</option>
                                </select>
                            </div>
                            {/*customerControllers && customerControllers.length && token ?
                                customerControllers.map((con, idx) =>
                                    <Websocket key={`ws-listener-${con.id}-${idx}-${token.accessToken}`}
                                               url={`${WS_URL}/controllers/${con.id}/?access_token=${token.accessToken}`}
                                               onMessage={this.handleCustomerControllerWebSocketResponse}/>) :
                                null*/}
                        </TabPane>
                    </TabContent>

                    <ControllerListTable
                        deletearchivecontrollers={deletearchivecontrollers}
                        highlightedID={highlightedController}
                        controllers={activeControllers}
                        showTeams={activeTab === '2'}
                        loadingControllers={loadingControllers}
                        sortBy={sortBy}
                        phone={phone}
                        sortDescending={sortDescending}
                        onRowMouseOver={pageHelpers.userOnMobileDevice() ? undefined : this.tableControllerMouseOverHandler}
                        onRowMouseOut={pageHelpers.userOnMobileDevice() ? undefined : this.tableControllerMouseOutHandler}
                        onRowClick={this.tableControllerClickHandler}
                        onSortClick={this.tableSortClickHandler}
                        clearSearch={this.clearSearch}
                        handleInput1Change={this.handleInput1Change}
                        selectable={this.user.isSupport || teamIsDealership? true : false}
                        actionName= {activeTab === '2' ? 'Unassign' : 'Selected'}
                        selectedControllers={selectedControllers}
                        onSelectedChange={this.handleSelectedControllersChange}
                        sortByField={this.state.sortByField}
                    />

                    {Math.ceil(activeControllerCount / RESPONSE_PAGE_SIZE) > 1 ?
                        <Row className="justify-content-center">
                            <Paginator
                                key={`paginator-${activeControllerCount}-${activeCurrentPage}-${RESPONSE_PAGE_SIZE}`}
                                count={activeControllerCount}
                                pageSize={RESPONSE_PAGE_SIZE}
                                currentPage={activeCurrentPage}
                                baseURL={activeBaseURL}/>
                        </Row> :
                        null}
                        {activeTab === '1' && (this.user.isSupport || teamIsDealership) &&deletearchivecontrollers?
                                    <Form className="col-12 m-2 p-4" onSubmit={this.submitDealerForm}>
                                        <div className="text-center mt-4">
                                            <div className="text-left">
                                                <Label>Customer Email</Label>
                                            </div>
                                            <Input type="email"
                                                   name="email"
                                                   className="col-12 col-md-8 d-inline-block"/>
                                            <Button
                                                className="mt-3 mt-md-0 offset-0 offset-sm-1 col-12 col-sm-5 col-md-3">
                                                Assign to Customer
                                            </Button>
                                            </div><br></br>
                                            <div className="text-center">
                                            <Button className="mt-3 mt-md-0 col-12 col-sm-6 col-md-4"
                                                onClick={
                                                this.submitDeleteController }> Delete Archive Controllers
                                            </Button>
                                        </div>
                                    </Form>:activeTab === '2' && (this.user.isSupport || teamIsDealership)?
                                    <Form className="p-0 text-center mt-4" onSubmit={this.submitUnassignForm}>
                                    <div className="text-center mt-4">
                                    <Button className="mt-3 mt-md-0 col-12 col-sm-6 col-md-4">
                                        Unassign
                                    </Button>
                                    </div>
                            
                                    </Form>:
                                     <div className="text-center">
                                     <Button className="mt-3 mt-md-0 col-12 col-sm-6 col-md-4"
                                         onClick={
                                         this.submitDeleteController }> Delete Archive Controllers
                                     </Button>
                                 </div>}
                                    <br />
                                    {(loading ? null :
                                    assignedControllers.length > 0 && token ?
                                        <div id="provisioned-controllers" className="row mt-4 justify-content-center align-items-center">
                                            <hr/>
                                            <br/>
                                            <h3 className="col-12 mt-3">Assigned Controllers</h3>
                                            <ListGroup>
                                                {assignedControllers.map((controller, idx) => (
                                                    <ControllerAssignmentListItem controller={controller}
                                                                                key={idx}
                                                                                token={token}
                                                                                handleWebSocketResponse={this.handleWebSocketResponse}/>
                                                ))}
                                            </ListGroup>
                                        </div>
                                        : null
                                        )}
                                    <br />
                                    {(unassignedControllers.length > 0 && token ?
                                        <div id="provisioned-controllers" className="row mt-4 justify-content-center align-items-center">
                                            <hr/>
                                            <br/>
                                            <h3 className="col-12 mt-3">Unassigned Controllers</h3>
                                            <ListGroup>
                                                {unassignedControllers.map((controller, idx) => (
                                                    <ControllerAssignmentListItem controller={controller}
                                                                                key={idx}
                                                                                token={token}
                                                                                handleWebSocketResponse={this.handleWebSocketResponse}/>
                                                ))}
                                            </ListGroup>
                                        </div>
                                        : null)}
                                        <br />

                    {activeControllers && !loadingControllers ?
                        <ControllerMap controllers={activeControllers}
                                       onControllerMouseOver={this.mapControllerMouseOverHandler}
                                       onControllerMouseOut={this.mapControllerMouseOutHandler}
                                       onControllerClick={this.mapControllerClickHandler}
                                       highlightedController={highlightedController}/> :
                        null}

                    {pageHelpers.renderErrorModalsForPage(errors, this)}
                    {pageHelpers.renderUserConfirmationModals(userConfirmationRequests)}
                    {pageHelpers.renderUserSelectionModals(userSelectionRequests)}

                    {teamID && token ?
                        <Websocket url={`${WS_URL}/teams/${teamID}/?access_token=${token.accessToken}`}
                                   onMessage={this.handleTeamWebSocketResponse}/> : null}

                </Col>

                {teamID && this.user && this.user.isSupport ?
                    <AdminLinkBubble url={`marksman_api/team/${teamID}`}
                                     modelName="team"
                                     className="mt-2"/> :
                    null}
            </div>)
    }
}



export default withRouter(ListPage)



// WEBPACK FOOTER //
// ./src/components/pages/controllers/ListPage.js